export default "__VITE_ASSET__BEIVwLYQ__"